import {useDispatch, useSelector} from 'react-redux'
import {AppStore} from '../redux/store'
import {
  addTabAction,
  changeTabAction,
  deleteTabAction,
  setCurrentTabItemAction,
} from '../redux/states/recreacion'
import {TabRecreacionModel} from '../models'
export const useRecreacion = () => {
  const recreacionState = useSelector((store: AppStore) => {
    console.log(store)
    return store.recreacion
  })
  console.log({recreacionState})
  const {tabs, currentTab} = recreacionState
  const currentTabItem = tabs[currentTab] || null
  const dispatch = useDispatch()

  const changeTab = (index: number) => {
    dispatch(changeTabAction(index))
  }

  const changeCurrentTabItem = (tab: TabRecreacionModel) => {
    dispatch(setCurrentTabItemAction(tab))
  }

  const addTab = (newTab: TabRecreacionModel) => {
    dispatch(addTabAction(newTab))
    return recreacionState.tabs.length
  }

  const deleteTab = (index: number) => {
    const updatedTabs = [...tabs]
    updatedTabs.splice(index, 1)
    dispatch(deleteTabAction(updatedTabs))
  }

  return {
    panel: recreacionState.showPanel,
    currentTabItem,
    tabs: recreacionState.tabs,
    currentTab: recreacionState.currentTab,
    addTab,
    deleteTab,
    changeTab,
    changeCurrentTabItem,
  }
}
